export default __webpack_public_path__ + "static/media/pier-paolo-pasolini.b2cbeca4.jpg";